var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.clients),callback:function ($$v) {_vm.clients=$$v},expression:"clients"}}),_c('div',{attrs:{"id":"clientPaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }